module.exports = __webpack_public_path__ + "static/media/nimes_maisoncarree.0c639d07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_maisoncarree.png
// module id = 731
// module chunks = 0